export class SnowflakeError extends Error {
  constructor(message: string) {
    super(message);
  }
}
